export function formatShortDate(d?: string): string {
  if (!d) return '—';
  const date = new Date(d);
  return Number.isNaN(date.getTime()) ? '—' : date.toLocaleDateString();
}

/**
 * Extract a value from a `metadata.ext` entry list of the form `"<key>:<value>"`.
 * Splits on the first colon only, since the value may itself contain colons or slashes.
 */
export function getExtValue(ext: string[] | undefined, key: string): string | undefined {
  if (!ext) return undefined;
  const prefix = `${key}:`;
  for (const entry of ext) {
    if (typeof entry === 'string' && entry.startsWith(prefix)) {
      return entry.slice(prefix.length);
    }
  }
  return undefined;
}
